import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-onverrekende-buitenlandse-bronheffing',
  templateUrl: './onverrekende-buitenlandse-bronheffing.component.html',
  styleUrls: ['./onverrekende-buitenlandse-bronheffing.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class OnverrekendeBuitenlandseBronheffingComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;

    @Input() public id!: string;
    public clientId!: string;

    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    private focusedElementId: string | null = null;

    public verrekenbareVerliezenFG = {} as FormGroup;

    get onverrekendeBuitenlandseBronheffing(): FormArray {
        return this.verrekenbareVerliezenFG.get('onverrekendeBuitenlandseBronheffing') as FormArray;
    }

    addRijOnverrekendeBuitenlandseBronheffing(): void {
        this.onverrekendeBuitenlandseBronheffing.push(this.createOnverrekendeBuitenlandseBronheffingFormGroup())
    }

    verwijderRijOnverrekendeBuitenlandseBronheffing(index: number): void {
        this.onverrekendeBuitenlandseBronheffing.removeAt(index);
        this.verrekenbareVerliezenFG.updateValueAndValidity()
        this.verrekenbareVerliezenFG.markAsDirty()
        this.saveForm();
    }

    createOnverrekendeBuitenlandseBronheffingFormGroup(verlies?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: verlies ? verlies.omschrijving : undefined,
            bedrag: verlies ? verlies.bedrag : undefined
        } as OmschrijvingEnBedrag);
    }



    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.verrekenbareVerliezenFG = this.fb.group({
            onverrekendeBuitenlandseBronheffing: this.fb.array<OmschrijvingEnBedrag>([]),
        });
    }

    public ngOnInit(): void {
      this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe(() => {
                    this.verrekenbareVerliezenFG.reset()
                    this.updateForm();
                })
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.verrekenbareVerliezenFG.dirty
  }

  private updateForm() {
        let bronheffingLijst = this.aangifte?.verliescompensatie?.onverrekendeBuitenlandseBronheffing || [];
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        this.partner.subscribe((partner) => {
            if (partner) {
                bronheffingLijst = this.aangifte?.partnerAangifte?.verliescompensatie?.onverrekendeBuitenlandseBronheffing || [];
            }
        });
        const formArrayBronheffing = this.verrekenbareVerliezenFG.get('onverrekendeBuitenlandseBronheffing') as FormArray;

        while (formArrayBronheffing.length > bronheffingLijst.length) {
            formArrayBronheffing.removeAt(formArrayBronheffing.length - 1);
        }
        for (let i = 0; i < bronheffingLijst.length; i++) {
            if (i < formArrayBronheffing.length) {
                const control = formArrayBronheffing.at(i) as FormGroup;
                control.patchValue(bronheffingLijst[i]);
            } else {
                const bronheffing = this.createOnverrekendeBuitenlandseBronheffingFormGroup(bronheffingLijst[i]);
                formArrayBronheffing.push(bronheffing);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.partner.subscribe((partner) => {
                if (!partner) {
                    this.incomeTaxEntity.aangifte = {
                        ...this.aangifte,
                        verliescompensatie: {
                            ...this.aangifte.verliescompensatie,
                            onverrekendeBuitenlandseBronheffing: this.verrekenbareVerliezenFG.value.onverrekendeBuitenlandseBronheffing,
                        }
                    } as Aangifte;
                    this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

                } else {
                    this.incomeTaxEntity.aangifte = {
                        ...this.aangifte,
                        partnerAangifte: {
                            ...this.aangifte.partnerAangifte,
                            verliescompensatie: {
                                onverrekendeBuitenlandseBronheffing: this.verrekenbareVerliezenFG.value.onverrekendeBuitenlandseBronheffing,
                            }
                        }
                    } as Aangifte;
                    this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

                }
            });
        }, 200)
    }
}



